import { style, compose, position, space, layout, flexbox, color, typography, border, opacity, boxShadow } from 'styled-system';
export { alignItems, background, border, borderBottom, borderColor, borderLeft, borderRadius, borderRight, borderTop, borders, bottom, boxShadow, color, compose, display, flex, flexDirection, flexbox, fontFamily, fontSize, fontWeight, height, justifyContent, layout, left, lineHeight, maxHeight, maxWidth, minHeight, minWidth, opacity, overflow, position, right, space, style, textAlign, textStyle, top, typography, variant, width, zIndex } from 'styled-system';

const float = style({
  prop: 'float',
  cssProperty: 'float'
});
const pointerEvents = style({
  prop: 'pointerEvents',
  cssProperty: 'pointer-events'
});
const outline = style({
  prop: 'outline',
  cssProperty: 'outline'
});
const cursor = style({
  prop: 'cursor',
  cssProperty: 'cursor'
});
const transition = style({
  prop: 'transition',
  cssProperty: 'transition'
});
const transform = style({
  prop: 'transform',
  cssProperty: 'transform'
});
const borderWidth = style({
  prop: 'borderWidth',
  cssProperty: 'border-width'
});
const borderStyle = style({
  prop: 'borderStyle',
  cssProperty: 'border-style'
});
const borderBottomLeftRadius = style({
  prop: 'borderBottomLeftRadius',
  cssProperty: 'border-bottom-left-radius'
});
const borderBottomRightRadius = style({
  prop: 'borderBottomRightRadius',
  cssProperty: 'border-bottom-right-radius'
});
const flexGrow = style({
  prop: 'flexGrow',
  cssProperty: 'flex-grow'
});
const letterSpacing = style({
  prop: 'letterSpacing',
  cssProperty: 'letter-spacing'
});
const userSelect = style({
  prop: 'userSelect',
  cssProperty: 'user-select'
});
const textOverflow = style({
  prop: 'textOverflow',
  cssProperty: 'text-overflow'
});
const textDecoration = style({
  prop: 'textDecoration',
  cssProperty: 'text-decoration'
});
const textTransform = style({
  prop: 'textTransform',
  cssProperty: 'text-transform'
});
const listStyle = style({
  prop: 'listStyle',
  cssProperty: 'list-style'
});
const boxSizing = style({
  prop: 'boxSizing',
  cssProperty: 'box-sizing'
});
const visibility = style({
  prop: 'visibility',
  cssProperty: 'visibility'
});
const whiteSpace = style({
  prop: 'whiteSpace',
  cssProperty: 'white-space'
});
const wordWrap = style({
  prop: 'wordWrap',
  cssProperty: 'word-wrap'
});
const wordBreak = style({
  prop: 'wordBreak',
  cssProperty: 'word-break'
});
const inset = style({
  prop: 'inset',
  cssProperty: 'inset'
});
const composedProps = compose(position, space, layout, flexbox, color, typography, border, opacity, float, boxShadow, pointerEvents, boxSizing, visibility, transition, textOverflow, textDecoration, textTransform, outline, cursor, whiteSpace, wordWrap, wordBreak, userSelect, transform, transition, inset);

export { borderBottomLeftRadius, borderBottomRightRadius, borderStyle, borderWidth, boxSizing, composedProps, cursor, flexGrow, float, inset, letterSpacing, listStyle, outline, pointerEvents, textDecoration, textOverflow, textTransform, transform, transition, userSelect, visibility, whiteSpace, wordBreak, wordWrap };
